export { CardVertical } from './CardVertical';
export { type CardVerticalProps, CardVerticalVariations } from './CardVertical.types';
